
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.238 23.997a.743.743 0 01-.53-.22l-3.293-3.294a5.99 5.99 0 01-3.677 1.264c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6a5.994 5.994 0 01-1.262 3.676l3.293 3.294c.142.142.22.33.22.53a.75.75 0 01-.751.75zm-7.5-12.75c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"}}),_c('path',{attrs:{"d":"M7.498 16.497a.751.751 0 01-.541-.231l-5.095-5.315A6.404 6.404 0 01.67 3.548 6.379 6.379 0 014.383.328a6.42 6.42 0 012.036-.333c.998 0 1.962.229 2.866.681.619.31 1.181.715 1.67 1.204l1.036 1.035 1.036-1.035a6.382 6.382 0 014.54-1.882c1.717 0 3.329.668 4.542 1.88.49.489.895 1.051 1.204 1.67a6.459 6.459 0 01-.021 5.79.747.747 0 01-1.009.328.75.75 0 01-.328-1.009 4.92 4.92 0 00-.906-5.718 4.889 4.889 0 00-3.479-1.441 4.888 4.888 0 00-3.481 1.443l-1.566 1.565a.748.748 0 01-1.06 0L9.895 2.941a4.896 4.896 0 00-1.28-.923 4.869 4.869 0 00-2.197-.523c-.528 0-1.053.086-1.562.255a4.894 4.894 0 00-2.845 2.469 4.917 4.917 0 00.922 5.683l5.106 5.327a.74.74 0 01.208.535.745.745 0 01-.749.733z"}})])
          )
        }
      }
    